import { getTestAttributes, noop, SkeletonLoader, sizing } from '@chillibean/component-library';
import { clsx } from 'clsx';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { AdminCard } from '../presentational';

export function AdminList(props) {
  const { elements, loading = false, onDelete = noop, onDuplicate = noop, rightSectionEnabled = false } = props;

  if (loading)
    return (
      <Container {...getTestAttributes('admin-list-loader')}>
        {[1, 2, 3].map((num) => (
          <SkeletonLoader
            key={num}
            height={66}
            preserveAspectRatio="none"
            style={{ borderRadius: sizing.xsmall, width: '100%' }}
            width={100}
          >
            <rect height={66} rx={0} ry={0} width="100%" x="0" y="0" />
          </SkeletonLoader>
        ))}
      </Container>
    );

  return (
    <Container>
      {elements.map((el, index) => (
        <AdminCard
          key={el?.id}
          disabled={el?.locked}
          extraclsx={clsx({
            card: true,
            last: index === elements.length - 1,
          })}
          header={el?.header}
          id={el?.id}
          onClick={el?.onClick}
          onDelete={onDelete}
          onDuplicate={onDuplicate}
          rightSectionEnabled={rightSectionEnabled}
          subHeader={el?.subHeader}
        />
      ))}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${sizing.medium};
`;

AdminList.propTypes = {
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string,
      id: PropTypes.number,
      locked: PropTypes.bool,
      onClick: PropTypes.func,
    }),
  ).isRequired,
  loading: PropTypes.bool,
  onDelete: PropTypes.func,
  onDuplicate: PropTypes.func,
  rightSectionEnabled: PropTypes.bool,
};

export default AdminList;
